/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/svg/css/svg';
import './link.scss';
import './modifier/anchor.scss';
import './modifier/content.scss';
import './modifier/underline.scss';
import './modifier/block.scss';
import './modifier/embedded.scss';
import './modifier/icon.scss';
import './modifier/icon-only.scss';
import './modifier/icon-size.scss';
import './modifier/disabled.scss';
import './modifier/mobile-icon-only.scss';
import './modifier/color.scss';
import './modifier/active.scss';
import './modifier/icon-animation.scss';
import './modifier/size.scss';
